/**
 * Mensagens da exclusão/troca de documento (VC-16). Fica fora do `documentoService` de
 * propósito: os testes que mockam o serviço inteiro não precisam repetir este helper.
 *
 * Textos de reserva para os códigos de conflito da exclusão/troca (VC-16). O `message` do
 * backend já vem em português e tem precedência; estes só cobrem resposta sem corpo nosso.
 */
export const MENSAGEM_POR_CODIGO: Record<string, string> = {
  DOCUMENTO_NAO_REMOVIVEL_TIPO: 'Este documento não pode ser removido pelo consultor.',
  RESERVA_NAO_SINCRONIZADA: 'A reserva ainda não está sincronizada; tente novamente em instantes.',
  RESERVA_FORA_DA_JANELA_DE_EDICAO:
    'Documentos só podem ser removidos ou trocados com a reserva em rascunho ou com pendência.',
  DOCUMENTO_DE_OUTRO_AUTOR: 'Só quem enviou o documento pode removê-lo.',
  ARQUIVO_IDENTICO_AO_ATUAL: 'O arquivo enviado é idêntico ao atual; nada a substituir.',
  VERIFICACAO_SEGURANCA_INDISPONIVEL: 'Verificação de segurança indisponível, tente novamente em instantes.',
  // Arquivo substituto em resposta de pendência (Onda 4, L11/Q38).
  PENDENCIA_NAO_SINCRONIZADA: 'A situação da pendência ainda não está sincronizada; tente novamente em instantes.',
  PENDENCIA_ENCERRADA: 'A pendência não está mais aberta: o arquivo da resposta não pode ser substituído.',
  MOTIVO_SUBSTITUICAO_OBRIGATORIO: 'Informe o motivo da substituição do arquivo.',
  // Reuso por CNPJ (Q42): sem autorização do servidor, pede novo envio.
  REUSO_NAO_AUTORIZADO: 'Não foi possível reaproveitar este documento. Envie um novo arquivo.',
  // Onda 5 (AN-11 §1.2): o PDF informativo vigente de um produto não sai nem é trocado direto.
  DOCUMENTO_E_INFORMATIVO_VIGENTE:
    'Este arquivo é o informativo vigente de um produto. Retire ou publique outro informativo na aba do produto antes de remover ou trocar o arquivo.',
}

/**
 * Mensagem legível de uma falha de exclusão/troca. O interceptor rejeita com
 * `{ message, status, data }` (não `Error`), e o código vem em `data.errorCode`.
 */
export const mensagemErroDocumento = (e: unknown, padrao: string): string => {
  const falha = e as { message?: string; data?: { message?: string; errorCode?: string } } | null
  if (falha?.data?.message) return falha.message || falha.data.message
  const codigo = falha?.data?.errorCode
  if (codigo && MENSAGEM_POR_CODIGO[codigo]) return MENSAGEM_POR_CODIGO[codigo]
  return falha?.message || padrao
}
